<template>
  <base-custom-drawer title="Productos">
    <div class="drawer__content-input">
      <a-input-search
        placeholder="Buscar por ID o nombre de producto"
        @search="handleSearch"
      />
    </div>
    <a-tabs
      v-model="tabSelected"
      size="small"
      :tabBarStyle="{ margin: '12px 20px 0px 20px' }"
      :style="{
        height: heightContainerTabs,
      }"
      class="drawer-products__tabs-container"
    >
      <a-tab-pane v-for="tab in tabs" :key="tab.key" :tab="tab.title">
        <custom-section-scroll
          :master-styles="{ height: tab.height }"
          :content-styles="{ padding: '0px 20px' }"
          :scroll-pagination="{
            observedElement: 'list-item--last',
            onNext: searchNextPage,
          }"
        >
          <p class="regular-12 text--left">
            Marca con check un producto para asignarlo a este ticket.
          </p>

          <ul
            class="drawer__list display-flex direction-column align--center"
            v-if="tabSelected === tab.key"
          >
            <template v-if="false">
              <list-item-product
                v-for="i in 8"
                :key="(i + 8).toString(36) + i"
                :loading="listProducts[tab.key].load"
              />
            </template>
            <template v-else>
              <!--si no hay productos-->
              <template v-if="!listProducts[tab.key].data.length">
                <svg width="1006" height="690" viewBox="0 0 1006 690" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:width="'120px'" v-bind:height="'100px'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M332.353 686.094H131.007V576.675h195.29" fill="#D9D9D9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M255.734 577.432a2.523 2.523 0 012.519 2.375l.004.148v60.891c0 2.495-3.21 3.452-4.592 1.445l-.079-.122-12.15-19.725-13.495 21.912c-.956 1.552-3.172 1.598-4.204.14l-.093-.141-15.34-24.928-15.263 24.924c-1.304 2.128-4.543 1.265-4.671-1.17l-.004-.145-.084-62.741a2.523 2.523 0 015.042-.155l.004.148.072 53.814 12.747-20.814c.954-1.557 3.174-1.606 4.208-.146l.093.141 15.345 24.937 13.495-21.91c.955-1.551 3.171-1.598 4.203-.141l.093.141 9.627 15.629v-51.984a2.523 2.523 0 012.375-2.519l.148-.004zM709.897 25.287a2.523 2.523 0 012.519 2.375l.004.148V48.5a2.523 2.523 0 01-5.042.148l-.004-.148V27.81a2.523 2.523 0 012.523-2.523z" fill="#BFBFBF"/><path fill-rule="evenodd" clip-rule="evenodd" d="M720.242 35.632a2.523 2.523 0 01.148 5.042l-.148.004h-20.69a2.523 2.523 0 01-.148-5.042l.148-.004h20.69zM562.546 101.149a2.523 2.523 0 012.518 2.375l.005.149v20.689a2.523 2.523 0 01-5.042.148l-.005-.148v-20.689a2.524 2.524 0 012.524-2.524z" fill="#BFBFBF"/><path fill-rule="evenodd" clip-rule="evenodd" d="M572.89 111.494a2.524 2.524 0 01.149 5.042l-.149.004h-20.689a2.522 2.522 0 01-.148-5.042l.148-.004h20.689zM443.623.477a2.524 2.524 0 012.519 2.374l.004.149v20.69a2.523 2.523 0 01-5.042.148l-.004-.149V3a2.523 2.523 0 012.523-2.522z" fill="#BFBFBF"/><path fill-rule="evenodd" clip-rule="evenodd" d="M453.968 10.821a2.523 2.523 0 01.148 5.042l-.148.005h-20.69a2.523 2.523 0 01-.148-5.042l.148-.005h20.69zM318.895 168.938a2.523 2.523 0 012.519 2.374l.004.149v20.773a2.523 2.523 0 01-5.042.149l-.004-.149v-20.773a2.523 2.523 0 012.523-2.523z" fill="#BFBFBF"/><path fill-rule="evenodd" clip-rule="evenodd" d="M329.24 179.366a2.523 2.523 0 01.148 5.042l-.148.004h-20.774a2.523 2.523 0 01-.148-5.042l.148-.004h20.774zM175.835 88.702a2.524 2.524 0 012.519 2.375l.004.148V112a2.523 2.523 0 01-5.042.148l-.004-.148V91.225a2.523 2.523 0 012.523-2.523z" fill="#BFBFBF"/><path fill-rule="evenodd" clip-rule="evenodd" d="M186.18 99.047a2.524 2.524 0 01.148 5.042l-.148.004h-20.69a2.523 2.523 0 01-.148-5.042l.148-.004h20.69zM153.211 395.851a2.522 2.522 0 012.518 2.374l.005.149v20.773a2.524 2.524 0 01-5.042.149l-.004-.149v-20.773a2.522 2.522 0 012.523-2.523z" fill="#BFBFBF"/><path fill-rule="evenodd" clip-rule="evenodd" d="M163.64 406.195a2.524 2.524 0 01.148 5.042l-.148.005h-20.774a2.523 2.523 0 01-.148-5.042l.148-.005h20.774zM111.663 224.446a2.525 2.525 0 012.519 2.375l.004.148v20.69a2.523 2.523 0 01-5.042.148l-.004-.148v-20.69a2.523 2.523 0 012.523-2.523z" fill="#BFBFBF"/><path fill-rule="evenodd" clip-rule="evenodd" d="M122.008 234.791a2.524 2.524 0 01.148 5.042l-.148.004h-20.69a2.523 2.523 0 01-.148-5.042l.148-.004h20.69zM803.673 283.908a2.523 2.523 0 012.518 2.375l.005.148v20.69a2.524 2.524 0 01-5.042.148l-.005-.148v-20.69a2.524 2.524 0 012.524-2.523z" fill="#BFBFBF"/><path fill-rule="evenodd" clip-rule="evenodd" d="M814.017 294.253a2.524 2.524 0 01.149 5.042l-.149.004h-20.689a2.522 2.522 0 01-.148-5.042l.148-.004h20.689zM841.94 112.083a2.523 2.523 0 012.519 2.375l.004.148v20.69a2.523 2.523 0 01-5.042.148l-.004-.148v-20.69a2.524 2.524 0 012.523-2.523z" fill="#BFBFBF"/><path fill-rule="evenodd" clip-rule="evenodd" d="M852.285 122.428a2.522 2.522 0 01.148 5.042l-.148.004h-20.69a2.524 2.524 0 01-.148-5.042l.148-.004h20.69zM918.559 416.288a2.523 2.523 0 012.519 2.375l.004.148v20.774a2.523 2.523 0 01-5.042.148l-.004-.148v-20.774a2.524 2.524 0 012.523-2.523z" fill="#BFBFBF"/><path fill-rule="evenodd" clip-rule="evenodd" d="M928.904 426.633a2.522 2.522 0 01.148 5.042l-.148.004h-20.689a2.524 2.524 0 01-.149-5.042l.149-.004h20.689zM719.484 442.445h-89.739c-.421 0-.757-.085-1.093-.253-.841 0-1.682-.42-2.103-1.177l-49.453-79.058v319.007c0 1.43-1.094 2.523-2.523 2.523-1.43 0-2.524-1.093-2.524-2.523v-321.53l-81.917 83.095a2.451 2.451 0 01-2.355 1.682H320.409c-.336 0-.588-.084-.841-.169V688.87h400.505V442.36c-.168.085-.336.085-.589.085zM535.38 580.46c0 6.98-5.635 12.615-12.616 12.615H365.153a12.599 12.599 0 01-12.616-12.615v-73.255a12.599 12.599 0 0112.616-12.616h157.611a12.599 12.599 0 0112.616 12.616v73.255zm129.016-22.204v85.366h-23.381v-86.88h-19.008l32.128-89.739 30.614 91.169h-20.353v.084z" fill="#BFBFBF"/><path fill-rule="evenodd" clip-rule="evenodd" d="M485.254 439.164v-14.887H226.465l-.252 14.971 259.041-.084zM812.252 422.512H632.269v14.886l179.983.084-.084-14.886" fill="#BFBFBF"/><path fill-rule="evenodd" clip-rule="evenodd" d="M812.168 416.708l-93.524-84.44h-29.269s2.103 28.763-23.717 32.8c-5.467 1.094-19.092-7.906-25.652-26.156-.336-2.439 5.215 36.081-17.157 38.099-29.689.252-69.554-42.893-69.554-42.893H319.569l-92.851 85.113h259.461l76.367-77.46c1.009-1.009 2.607-1.009 3.533 0 1.009 1.01 1.009 2.608 0 3.533l-75.863 76.955v12.868l81.75-82.927c.336-.336.757-.588 1.177-.673.084-.084.169-.168.253-.168 1.177-.757 2.775-.42 3.448.841l50.294 80.488v-11.69l-33.726-53.07c-.756-1.178-.42-2.776.757-3.448 1.178-.757 2.776-.421 3.449.756l33.305 52.313h181.076" fill="#BFBFBF"/><path fill-rule="evenodd" clip-rule="evenodd" d="M572.386 352.873c.42-.757 1.261-1.261 2.102-1.261-.42-.084-.841-.168-1.261 0-.421.336-.673.757-.841 1.261z" fill="#BFBFBF"/><path fill-rule="evenodd" clip-rule="evenodd" d="M376.357 78.506c-15.895.683-30.934 8.418-44.187 20.962l-.466.445c-11.179 10.674-18.523 26.142-17.688 36.469.473 5.854 3.657 9.742 9.088 10.188 5.18.425 12.068-2.365 20.609-8.397l1.435-1.017c15.981-11.224 28.184-14.376 38.23-10.649 9.275 3.441 17.309 12.767 26.138 29.479 4.612 8.663 3.749 19.321-2.097 32.545-4.829 10.925-12.377 22.557-25.041 39.576l-2.176 2.912-9.114 12.101c-10.838 14.429-14.922 20.221-19.861 28.284-13.326 21.707-20.317 43.823-20.052 62.749l.007.147a2.522 2.522 0 002.516 2.341h158.644a2.483 2.483 0 002.422 1.07l7.817-1.07h50.289l.593.563c12.339 11.673 28.702 24.323 42.576 32.173 8.81 4.986 16.55 8.055 22.94 8.841 7.697.948 13.537-1.455 16.632-7.55l.285-.562c3.753-7.501 5.922-15.28 6.329-22.882l.022-.458.136.213c2.477 3.863 5.119 7.461 7.902 10.589 7.684 8.636 15.321 12.23 22.48 8.279l.385-.217c12.289-7.059 20.562-24.97 19.068-42.683l-.034-.38.242-.229c8.057-7.684 14.076-15.539 17.969-23.664l.237-.501-.043.079c15.084-27.189 13.514-53.818-.53-77.501-10.203-17.205-27.468-32.028-37.769-34.821-10.083-2.773-19.237-3.238-26.794-2.333l-.768.098-.575.081-.17-.343c-4.219-8.371-11.218-16.943-20.244-25.512-5.299-5.031-10.968-9.745-16.637-14.015a185.933 185.933 0 00-5.485-3.983l-.824-.57-.936-.636-.352-.234a2.524 2.524 0 00-2.546-.128c-10.092 5.242-15.151 16.647-16.422 32.181-.683 8.347-.221 17.241.964 25.908l.094.674.191 1.309c.162 1.068.327 2.079.494 3.026l.093.524-9.947 3.745-.515-.618-1.091-1.298c-17.91-21.18-39.506-40.895-46.722-41.34-5.275-.363-9.04 4.193-11.86 12.327-2.168 6.251-3.808 14.731-5.011 24.919-.912 7.732-1.521 16.003-1.885 24.271l-.066 1.557a377.352 377.352 0 00-.152 4.401l-.061 2.39-.025 1.265-6.586 3.925c-39.237 23.418-69.921 42.375-94.574 58.669l-2.015 1.335.035-.215c2.427-14.575 10.287-31.504 24.16-50.342 33.171-45.088 38.071-102.392 9.229-136.432-19.258-22.727-39.112-32.88-58.93-32.03zm55.08 35.292c27.147 32.04 22.463 86.81-9.443 130.179-16.192 21.986-24.558 41.695-25.799 58.5-.155 2.098 2.175 3.454 3.922 2.281l3.298-2.205c26.682-17.767 60.683-38.735 105.417-65.341a2.525 2.525 0 001.226-1.986l.043-2.447.048-2.013c.054-2.025.131-4.224.234-6.561.359-8.154.96-16.306 1.856-23.902l.148-1.223c2.451-19.824 6.733-31.898 11.382-31.579 5.498.34 28.671 21.824 45.91 42.819a2.525 2.525 0 002.84.76l13.624-5.131a2.523 2.523 0 001.578-2.894l-.1-.485-.159-.824a127.254 127.254 0 01-.961-5.986c-1.139-8.333-1.584-16.88-.935-24.813l.043-.503c1.134-12.88 5.059-22.209 12.237-26.781l.162-.102.723.502a181.68 181.68 0 015.336 3.874c5.525 4.161 11.049 8.756 16.197 13.643 9.36 8.886 16.39 17.714 20.132 26.052a2.522 2.522 0 002.728 1.454l.391-.082.316-.06c.509-.095 1.114-.19 1.809-.28 7.024-.905 15.696-.513 25.32 2.134 3.593.974 9.61 4.654 15.661 9.849 7.274 6.244 13.979 14.047 19.098 22.678 13.169 22.208 14.627 46.938.458 72.479l-.081.158c-3.764 8.076-9.876 15.976-18.27 23.776a2.524 2.524 0 00-.788 2.147c1.965 16.478-5.716 33.472-16.712 39.545-4.453 2.457-9.977-.142-16.271-7.217-4.716-5.3-9.106-12.213-12.911-19.422-1.362-2.581-5.288-1.176-4.703 1.683 2.067 10.107.122 21.259-5.325 31.902-3.935 7.747-15.406 6.335-32.592-3.39-13.974-7.908-30.699-20.944-42.89-32.685a2.525 2.525 0 00-1.751-.706h-51.471l-.172.006a2.474 2.474 0 00-.171.017l-4.968.679-.086-.08a2.476 2.476 0 00-1.668-.622H336.231l.014-.559c.492-17.021 6.989-36.741 18.843-56.271l1.104-1.799c4.612-7.45 8.806-13.344 19.338-27.357l8.711-11.565a934.151 934.151 0 002.185-2.924l1.006-1.355c12.275-16.574 19.711-28.128 24.603-39.194 6.412-14.505 7.399-26.694 1.939-36.949l-.623-1.17c-9.122-16.987-17.717-26.781-28.218-30.677-11.858-4.399-25.649-.842-42.847 11.224l-1.057.75c-7.867 5.621-13.902 8.104-17.712 7.792-2.734-.225-4.183-1.994-4.472-5.566-.69-8.541 5.824-22.377 15.789-32.071l.358-.344c12.556-12.032 26.684-19.38 41.382-20.012 18.136-.779 36.551 8.64 54.863 30.25z" fill="#BFBFBF"/><path fill-rule="evenodd" clip-rule="evenodd" d="M755.586 186.021a2.524 2.524 0 01.611 5.007l-.94.104-.606.075a85 85 0 00-1.369.185l-.375.055c-2.551.376-5.399.892-8.468 1.57-8.766 1.936-17.53 4.773-25.686 8.67-12.173 5.817-21.886 13.483-28.278 23.218a2.524 2.524 0 01-4.218-2.769c6.952-10.588 17.378-18.817 30.32-25.002 8.536-4.079 17.657-7.031 26.774-9.044l1.456-.314c2.639-.553 5.109-.989 7.364-1.321l.778-.112c.251-.035.493-.068.726-.098l.99-.124c.441-.052.751-.085.921-.1zM720.761 228.795c14.943-6.091 30.199-8.076 42.744-4.417a2.523 2.523 0 11-1.413 4.845c-11.294-3.294-25.447-1.453-39.426 4.245-11.586 4.724-21.498 11.684-23.629 15.984a2.523 2.523 0 11-4.521-2.241c2.816-5.683 13.618-13.268 26.245-18.416zM551.953 268.647c10.726-1.146 21.649.22 30.722 3.191a2.523 2.523 0 01-1.571 4.796c-8.422-2.759-18.635-4.036-28.614-2.97-12.708 1.358-24.253 6.352-33.864 15.595a2.524 2.524 0 01-3.498-3.637c10.456-10.056 23.05-15.504 36.825-16.975zM546.854 249.351c14.502-.097 27.865 3.809 35.427 10.362a2.524 2.524 0 01-3.305 3.814c-6.527-5.656-18.715-9.219-32.088-9.129-14.891.099-29.538 4.584-41.02 13.271a2.523 2.523 0 11-3.045-4.024c12.396-9.378 28.1-14.187 44.031-14.294zM529.185 170.061a2.523 2.523 0 014.706 1.818l-.359.894-.339.876a96.72 96.72 0 00-.497 1.335c-.87 2.39-1.742 5.038-2.555 7.869-1.948 6.783-3.249 13.496-3.602 19.722-.644 11.358 1.925 19.81 8.308 24.457a2.523 2.523 0 01-2.971 4.079c-8.045-5.857-11.106-15.927-10.375-28.822.377-6.647 1.746-13.713 3.79-20.83a124.51 124.51 0 012.664-8.202l.267-.727c.131-.352.258-.686.38-1.002l.446-1.132.137-.335zM599.483 145.864a2.524 2.524 0 014.884 1.26l-.215.791-.234.892a129.486 129.486 0 00-1.76 8.022c-1.724 9.209-2.561 18.544-2.03 27.203.384 6.266 1.481 11.887 3.37 16.7a2.523 2.523 0 11-4.697 1.844c-2.099-5.349-3.296-11.477-3.71-18.235-.56-9.128.313-18.856 2.107-28.44.451-2.411.932-4.647 1.416-6.669l.145-.6c.125-.509.244-.981.357-1.411l.326-1.213.041-.144zM605.588 255.398c3.427-1.177 4.699-6.512 2.842-11.915-1.857-5.403-6.14-8.829-9.566-7.651-3.426 1.177-4.699 6.512-2.842 11.915 1.857 5.403 6.14 8.829 9.566 7.651zM654.805 239.767c3.426-1.177 4.699-6.512 2.842-11.915-1.857-5.403-6.14-8.829-9.566-7.651-3.426 1.177-4.699 6.512-2.842 11.915 1.857 5.403 6.14 8.829 9.566 7.651zM650.435 249.845l-6.055 10.009c-.841 1.43-2.776 1.85-4.29 1.009l-9.335-5.551c-2.271-1.345-1.851-4.541.757-5.298l15.391-4.374c2.607-.841 4.878 1.935 3.532 4.205z" fill="#BFBFBF"/><path fill-rule="evenodd" clip-rule="evenodd" d="M639.546 259.735c-.558-2.942 3.564-4.232 4.783-1.497 1.541 3.456 4.181 7.233 6.237 8.816l.442.34c.862.646.805.333 1.125-2.522a2.523 2.523 0 115.015.562c-.78 6.969-5.027 9.188-9.661 5.618-.682-.525-1.381-1.183-2.075-1.939l-.093-.104-.005.122c-.071 1.355-.233 2.59-.496 3.629l-.083.305c-.802 2.822-2.585 4.655-5.337 4.303-2.234-.285-4.497-2.121-7.177-5.524a2.523 2.523 0 113.964-3.122c1.548 1.966 2.758 3.084 3.449 3.48l.057.031.009-.019c.043-.103.089-.228.135-.375l.047-.154c.7-2.465.501-7.532-.336-11.95zM588.875 329.57a2.524 2.524 0 013.534-.495c6.829 5.151 14.023 14.153 21.145 25.512l.388.622c4.795 7.708 9.631 16.828 10.597 19.402a2.523 2.523 0 01-4.669 1.909l-.195-.484c-1.121-2.672-5.597-11.055-10.018-18.162l-.744-1.187c-6.701-10.604-13.433-18.975-19.543-23.583a2.524 2.524 0 01-.495-3.534zM610.807 323.883l.134.178c.151.188.193.149.765.34a2.523 2.523 0 011.596-4.787l.154.057c1.115.461 2.01 1.86 4.454 6.092a170.385 170.385 0 016.497 12.475c5.815 12.371 9.484 23.863 9.795 33.053a2.523 2.523 0 01-5.044.171c-.281-8.35-3.77-19.274-9.318-31.077a167.142 167.142 0 00-5.914-11.426l-.758-1.313a80.882 80.882 0 00-1.631-2.678l-.338-.519c-.158-.238-.291-.43-.392-.566z" fill="#BFBFBF"/><path fill-rule="evenodd" clip-rule="evenodd" d="M541.742 303.156c25.777-9.88 49.545-12.278 66.338-4.641 17.389 7.889 28.177 19.246 32.283 32.977 3.674 12.287 1.781 25.96-4.835 39.007a2.523 2.523 0 01-4.5-2.283c6.064-11.959 7.776-24.324 4.5-35.278-3.664-12.253-13.41-22.513-29.535-29.829-15.295-6.955-37.809-4.684-62.445 4.759-20.556 7.879-40.207 20.14-47.249 28.846a2.523 2.523 0 01-3.923-3.174c7.693-9.511 28.055-22.216 49.366-30.384zM648.336 316.157a2.524 2.524 0 013.332.926l.1.181.594 1.153.568 1.121c.383.761.791 1.581 1.218 2.453l.259.529c1.99 4.08 3.98 8.394 5.838 12.754a194.82 194.82 0 013.76 9.445c2.98 8.137 4.708 14.897 4.848 19.943a2.522 2.522 0 11-5.044.14c-.122-4.369-1.736-10.683-4.542-18.348a192.757 192.757 0 00-3.663-9.201 274.005 274.005 0 00-5.732-12.52l-.748-1.522c-.242-.488-.476-.956-.701-1.404l-.771-1.518-.375-.724a2.524 2.524 0 011.059-3.408zM669.155 309.014a2.523 2.523 0 013.188 1.603l.321 1.001.336 1.087a196.028 196.028 0 012.994 11.012c1.267 5.27 2.269 10.423 2.907 15.279l.141 1.119c1.185 9.812.743 17.596-1.878 22.807a2.523 2.523 0 11-4.508-2.268c2.141-4.257 2.476-11.592 1.241-21.002-.612-4.663-1.581-9.646-2.81-14.755a190.352 190.352 0 00-2.188-8.273l-.249-.855a160.23 160.23 0 00-.476-1.589l-.573-1.83-.049-.148a2.523 2.523 0 011.603-3.188z" fill="#BFBFBF"/><path fill-rule="evenodd" clip-rule="evenodd" d="M645.305 288.91c15.792-4.668 29.477-2.169 37.884 9.683 2.903 4.079 6.477 12.253 8.345 18.295a2.523 2.523 0 01-4.821 1.491c-1.723-5.574-5.101-13.298-7.638-16.863-6.947-9.795-18.402-11.887-32.34-7.766-10.368 3.064-21.504 9.902-24.007 13.636l-.093.144a2.524 2.524 0 01-4.282-2.67c3.071-4.925 15.375-12.527 26.952-15.95zM1002.83 684.244c1.4 0 2.53 1.13 2.53 2.523a2.531 2.531 0 01-2.38 2.519l-.15.004H3.337a2.523 2.523 0 01-.149-5.042l.149-.004h999.493z" fill="#BFBFBF"/></svg>
                <p>No se encontraron coincidencias</p>
              </template>
              <template v-for="(product, index) in listProducts[tab.key].data">
                <!--Si los productos han cargado-->
                <list-item-product
                  :key="`${new Date()}${product._id}`"
                  :data-source="product"
                  @onChecked="
                    handleChecked(
                      $event,
                      tab.key,
                      product._id,
                      product.idAssigned
                    )
                  "
                  :show-checked="disabledAll"
                  :class="{
                    'list-item--last':
                      index === listProducts[tab.key].data.length - 1,
                  }"
                  :loading="listProducts[tab.key].load"
                />
                <a-divider :key="`divider_${index}`" class="drawer__divider" />
              </template>
              <!-- <a-spin v-if="loadingList" /> -->
            </template>
          </ul>
        </custom-section-scroll>
        <div
          v-if="tab.footer"
          class="drawer__footer display-flex justify-content--end"
        >
          <a-button
            v-if="!disabledAll"
            type="primary"
            @click="handleSubmitAssign"
            :loading="loadingAssign"
            :disabled="disabledBtnAssign"
            >Asignar productos</a-button
          >
        </div>
      </a-tab-pane>
    </a-tabs>
  </base-custom-drawer>
</template>

<script>
import ListItemProduct from '@/app/tickets/components/organisms/lists/ListItemProduct'
import BaseCustomDrawer from '@/app/tickets/components/organisms/sections/BaseCustomDrawer'
import CustomSectionScroll from '@/app/shared/components/sections/CustomSectionScroll'
import attemptMixin from '@/app/shared/mixins/attempt'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'DrawerListProducts',
  mixins: [attemptMixin],
  props: {},
  components: {
    BaseCustomDrawer,
    ListItemProduct,
    CustomSectionScroll,
  },
  data: () => ({
    tabSelected: 'assigned', // assigned: productos asignados al ticket | all: todos los productos excepto los asignados
    tabs: [
      {
        key: 'assigned',
        title: 'Asignados',
        height: 'calc(100% - 4em)',
      },
      {
        key: 'all',
        title: 'Todos',
        footer: true,
        height: 'calc(100% - 7.6em)',
      },
    ],
    loadingList: false,
    lastChild: null,
    observer: null,
    lastIndexData: 0,
    newProductsAssigned: [],
    loadingAssign: false,
    listProducts: {
      assigned: { data: [], load: true, morePaginate: true },
      all: { data: [], load: true, morePaginate: true },
    },
    assignedProducts: {
      page: 1,
      search: '',
    },
    allProducts: {
      page: 1,
      search: '',
      status: 'enable',
    },
  }),
  created() {
    this.intervalAttempt(() => {
      if (!this.ticketSelected) throw 'No ticket selected'
      this.loadFirstData()
    })
  },
  mounted() {
    this.intervalAttempt(() => {
      if (!this.assigned_products.length) throw 'No assigned products'
      this.listProducts.assigned.data = this.assigned_products
    })
  },
  watch: {
    assigned_products: {
      deep: true,
      handler() {
        this.listProducts.assigned.data = this.assigned_products
      },
    },
    company_products: {
      deep: true,
      handler() {
        this.listProducts.all.data = this.filterCompanyProducts(
          this.company_products
        )
      },
    },
  },
  computed: {
    ...mapGetters([
      'assigned_products',
      'company_products',
      'profileRemote',
      'ticketSelected',
      'active_breakpoint',
    ]),

    /**
     * Palabra 'segura' segun el genero
     * @returns {String}
     */
    wordSure() {
      return this.profile && this.profile.gender
        ? this.transformWordGender('segura', this.profile.gender)
        : 'segur@'
    },
    /**
     * @returns {Boolean}
     */
    disabledAll() {
      return this.profileRemote ? true : false
    },
    /**
     * Deshabilita el boton de asignar
     * @returns {Boolean}
     */
    disabledBtnAssign() {
      if (this.disabledAll) return true
      else if (!this.newProductsAssigned.length) return true
      else return false
    },
    /**
     * @return {String} altura del contenedor de tabs
     */
    heightContainerTabs() {
      const heightContentInput = '32px'
      // cuando es mobile, el titulo no se muestra
      const heightContentTitle = this.active_breakpoint.is_mobile
        ? '0px'
        : '48px'
      return `calc(100% - (${heightContentInput} + ${heightContentTitle}))`
    },
  },
  methods: {
    ...mapActions([
      'getCompanyProducts',
      'getAssignedProducts',
      'assignProducts',
      'removeAssignedProduct',
    ]),

    /**
     * Checkear el checkbox
     * @param {Boolean} checked
     * @param {String} key - id del tab selecionado
     * @param {String} idProduct
     */
    handleChecked(checked, key, idProduct) {
      // si se desasigna
      if (key === 'assigned' && !checked)
        return this.showDeleteConfirm(idProduct)
      // si se asigna un nuevo producto
      else if (key === 'all')
        return this.handleAddProductAssigned(idProduct, checked)
    },
    /**
     * Busca en la siguiente pagina dependiendo del tab
     */
    async searchNextPage() {
      // this.loadingList = true
      let response = null
      if (this.tabSelected === 'assigned') {
        this.assignedProducts.page = this.assignedProducts.page + 1
        response = await this.getAssignedProducts({
          page: this.assignedProducts.page,
          search: this.assignedProducts.search,
          next: true,
          idTicket: this.ticketSelected._id,
        })
      } else {
        this.allProducts.page = this.allProducts.page + 1
        response = await this.getCompanyProducts({
          page: this.allProducts.page,
          search: this.allProducts.search,
          status: this.allProducts.status,
          customFields: [],
          next: true,
        })
      }

      let morePaginate = true

      if (response.result.data.length === 0) {
        this.listProducts[this.tabSelected].morePaginate = false
        morePaginate = this.listProducts[this.tabSelected].morePaginate
      }

      return { morePaginate }
    },
    /**
     * Mostrar la confirmacion para eliminar
     * @param {String} idProduct
     */
    showDeleteConfirm(idProduct) {
      const self = this
      this.$confirm({
        title: `¿Estás ${self.wordSure} de desasignar este producto?`,
        content: 'Recuerda que se removerá de tu lista de asignados.',
        okText: 'Desasignar',
        cancelText: 'Cancelar',
        async onOk() {
          const response = await self.removeAssignedProduct(idProduct)
          if (response.success) self.$message.success(response.details)
          else self.$message.error(response.details)
        },
      })
    },
    /**
     * Añade un producto asignado
     * @param {String} idProduct
     * @param {Boolean} checked
     */
    handleAddProductAssigned(idProduct, checked) {
      // remueve el id del producto
      if (!checked)
        this.newProductsAssigned = this.newProductsAssigned.filter(
          (newProduct) => newProduct !== idProduct
        )
      // agrega el nuevo producto
      else this.newProductsAssigned.push(idProduct)

      const indexProduct = this.listProducts.all.data.findIndex(
        (product) => product._id === idProduct
      )
      if (indexProduct === -1) return
      else {
        const newProduct = { ...this.listProducts.all.data[indexProduct] }
        newProduct.assign = checked
        this.$set(this.listProducts.all.data, indexProduct, newProduct)
      }
    },
    /**
     * Envia todos los productos a la endpoint
     */
    async handleSubmitAssign() {
      this.loadingAssign = true
      const response = await this.assignProducts(this.newProductsAssigned)
      if (response.success) {
        this.$message.success(
          response.details
            ? response.details
            : 'Su producto se asoció correctamente'
        )
        if (response.associatedProducts === 0)
          this.$message.warning('Algunos productos no se han asociado')
      } else {
        this.$message.error(
          response.details ? response.details : 'Ocurrió un error 😥'
        )
      }
      this.loadingAssign = false
      this.handleReset()
    },
    /**
     * Resetea los valores primordiales
     */
    handleReset() {
      this.newProductsAssigned = []
      this.listProducts.all.data.forEach((elem) => (elem.assign = false))
      this.listProducts.all.data = this.filterCompanyProducts(
        this.company_products
      )
    },
    /**
     * Escucha el evento de buqueda
     */
    async handleSearch(value, tab) {
      if (!value) value = ''
      if (!tab || typeof tab !== 'string') tab = this.tabSelected
      this.loadingList = true
      if (tab === 'assigned') {
        this.assignedProducts.page = 1
        await this.getAssignedProducts({
          page: 1,
          search: value,
          idTicket: this.ticketSelected._id,
        })
      } else {
        this.allProducts.page = 1
        await this.getCompanyProducts({
          page: 1,
          search: value,
          status: this.allProducts.status,
          customFields: [],
        })
      }
      this.loadingList = false
    },
    /**
     * Filtra los productos de la empresa
     */
    filterCompanyProducts(company_products) {
      const idsAssignedProducts = this.assigned_products.map(
        (assigned) => assigned._id
      )
      const arr = company_products.filter(
        (companyProduct) =>
          !idsAssignedProducts.includes(companyProduct._id) &&
          companyProduct.active &&
          !companyProduct.deleted
      )
      return arr
    },
    /**
     * Carga la data inicial para productos
     */
    async loadFirstData() {
      // despues de cargado la data de productos
      this.listProducts.assigned.load = true
      this.listProducts.all.load = true
      await this.getCompanyProducts({
        page: 1,
        search: '',
        status: 'enable',
        customFields: [],
      })
      await this.handleSearch('', 'assigned')
      this.listProducts.assigned.load = false
      this.listProducts.all.load = false
      this.intervalAttempt(() => {
        if (!this.company_products.length) throw 'No products'
        this.listProducts.all.data = this.filterCompanyProducts(
          this.company_products
        )
      })
    },
  },
}
</script>

<style lang="sass" scoped>
.drawer__list
  padding: 0px
  margin-top: 12px
.list-item--last
  // border: 1px solid black
.drawer__content-input
  padding: 0px 20px
.drawer__divider
  margin: 8px 0px
.drawer__footer
  padding: 12px
  border-top: 1px solid $gray_5
</style>
<style lang="sass">
.drawer-products__tabs-container
  .ant-tabs-content
    height: 100%
</style>
